import { render, staticRenderFns } from "./FeesPanel.vue?vue&type=template&id=524284eb&"
import script from "./FeesPanel.vue?vue&type=script&lang=js&"
export * from "./FeesPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeesPanel.vue?vue&type=style&index=0&id=524284eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports